<div class="field-set">
  <label label>Selecionar variável</label>

  <app-select-box
    class="select-field"
    [(value)]="fieldSelected"
    (valueChange)="onFieldSelected($event)"
    [items]="fieldsObservable | async"
    displayExpr="alias"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-select-box>
</div>

<div
  class="chart"
  echarts
  [autoResize]="true"
  [options]="barChartOptions"
  [appBlockModalDrag]="!(isMobileModeObservable | async)"
></div>
